// @ts-nocheck
import React from "react";
import "./SiteTile.css";
import { t } from "i18next";
import SiteLogo from "../SiteLogo/SiteLogo";
import SaveFavSites from "components/Sites/SaveFavSites/SaveFavSites.component";
import { useAccountContext } from "providers/AccountProvider";
import clsx from "clsx";

export default function SiteTile(props) {
	const { site, TotalEmployes } = props;
	const { userOrAdmin } = useAccountContext();
	const [isHover, setIsHover] = React.useState(false);
	return (
		<div className={clsx("SiteTile tile", isHover ? "isHover" : "")} onClick={props.onClick} onMouseEnter={() => setIsHover(!isHover)} onMouseLeave={() => setIsHover(!isHover)}>
			<SiteLogo
				className="me-3"
				imgAlt={[site.siteName, site.address, site.country].join("-")}
				siteId={site.id}
				companyId={site.companyId}
			/>
			{userOrAdmin === "admin" && (
				<SaveFavSites
					className={"unstyled ms-auto"}
					siteId={site.id}
				/>
			)}
			<div className="d-flex flex-column w-100 overflow-hidden">
				<div className="title font-bold mb-1">{site.siteName}</div>
				<div className="location">
					{[site.address, site.town, site.country].filter(a => a).join(" - ")}
				</div>
				<div className="mt-auto">
					<div className="nbr-member-txt">
						{t("Sites.MEMBERS", { count: TotalEmployes })}
					</div>
					{/* <InfosFetcher
						className="nbr-member-txt"
						queryKey={["Employes", "EmployeOfSite", site.id]}
						queryFn={() =>
							genRequest("employees/site/" + site.id)
						}
						treat={(infos) => {
							return infos.length
								? t("Sites.MEMBERS", { count: infos?.length })
								: false;
						}}
					/> */}
					{/* <AsyncUsersList
						queryKey={["employees", "site", site.id]}
						queryFn={() =>
							genRequest("employees/site/" + site.id)
						}
						max={10}
						width={20}
					/> */}
				</div>
			</div>
		</div>
	);
}
